<script lang="ts">
  import { fly } from 'svelte/transition';
  import ArrowUp from '~icons/mdi/arrow-up';
  import ArrowDown from '~icons/mdi/arrow-down';
  import type { Snippet } from 'svelte';

  type Props = {
    scrollOffset: number;
    listHeight: number;
    itemHeight: number;
    index: number;
    onScrollToIndex: (pos: number) => void;
    children: Snippet;
  };

  const props: Props = $props();
</script>

{#if (props.scrollOffset + props.listHeight) / props.itemHeight < props.index}
  <div class="jump bottom" transition:fly={{ y: 100 }}>
    <button onclick={() => props.onScrollToIndex(props.index)}>
      <ArrowDown />
      {@render props.children()}
    </button>
  </div>
{:else if props.scrollOffset / props.itemHeight > props.index}
  <div class="jump top" transition:fly={{ y: -100 }}>
    <button onclick={() => props.onScrollToIndex(props.index)}>
      <ArrowUp />
      {@render props.children()}
    </button>
  </div>
{/if}

<style lang="scss">
  @use '~/theme/theme';
  @use '~/theme/themify' as *;
  .jump {
    position: absolute;
    left: 50%;
    &.top {
      top: 0;
    }
    &.bottom {
      bottom: 0;
    }
    padding: 0.5em 0;
  }
  button {
    border: none;
    cursor: pointer;
    border-radius: 999px;
    padding: 0.5em 1em;
    transform: translate(-50%);
    display: flex;
    align-items: center;
    gap: 0.5em;
    box-shadow: 0 0 8px #00000040;
    @include themify {
      color: themed('text');
      background-color: themed('tile-blue');
    }
  }
</style>
